import { useFormikContext } from "formik";
import React from "react";
import { TFormValues } from "../types";
import useLocalStorage from "../../../util/useLocalStorage";
import usePrevious from "../../../util/usePrevious";
interface Props {
  children: React.ReactNode;
}

export default function FormikLocalStorageProvider({ children }: Props) {
  const { values, setValues } = useFormikContext<TFormValues>();
  const prevValues = usePrevious(values);
  const [localFormValues, setFormValues] = useLocalStorage("formValues", values);
  const [firstLoad, setFirstLoad] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (window.location.pathname === '/legal-resources/' && !window.__guided_search?.loaded){
      window.__guided_search = { loaded: true };
      setFormValues(values);
    } else {
      if (localFormValues && firstLoad) {
        setValues(localFormValues, false);
        setFirstLoad(false);
      } else if (JSON.stringify(prevValues) !== JSON.stringify(values)) {
        setFormValues(values);
      }
    }
  }, [values, setFormValues, localFormValues, setFirstLoad, firstLoad, setValues, prevValues]);

  return <>{children}</>;
}
